import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Navigator from './Navigator';
import Home from './pages/Home';
import Users from './pages/Users';
import Team from './pages/Team';
import Me from './pages/Me';
import Reports from './pages/Reports';
import Feeds from './pages/Feeds';
import Jobs from './pages/Jobs';
import Tags from './pages/Tags';
import Prompts from './pages/Prompts';
import Portfolio from './pages/Portfolio';
import AutoreplyEmail from './pages/AutoreplyEmail';
import Settings from './pages/Settings';
import FeedContents from './pages/FeedContents';
import CoverLetters from './pages/CoverLetters';
import Header from './Header';
import Button from '@mui/material/Button';
import Breadcrumbs from './pages/parts/Breadcrumbs';
import InactivityHandler from './pages/parts/InactivityHandler';
import { Route, Routes, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import endpoints, { getBackendUrl } from '../endpoints';
import axios from 'axios';
import theme from '../theme';

import {wssClient} from '../wssClient'

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center" sx={{ fontSize: 13 }}>
            {'Gerda · © '}
            {new Date().getFullYear()}{' '}
            <Link color="inherit" underline="hover" href="https://greenice.net/">
                Greenice
            </Link>
        </Typography>
    );
}

const drawerWidth = 256;

export default function AdminPanel(props) {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

    const role = useSelector((state) => state.auth.userdata.role)
    const token = useSelector((state) => state.auth.token)

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    
    useEffect(() => {
        wssClient.init(token)
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                <CssBaseline />
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                >
                    {isSmUp ? 
                        <Navigator
                            authuserrole={role}
                            PaperProps={{ style: { width: drawerWidth } }}
                            sx={{ display: { sm: 'block', xs: 'none' } }}
                        />
                    : 
                        <Navigator
                            authuserrole={role}
                            PaperProps={{ style: { width: drawerWidth } }}
                            variant="temporary"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                        />
                    }
                </Box>
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, maxWidth: '100vw' }}>
                    <Header
                        navigatorWidth={drawerWidth}
                        onDrawerToggle={handleDrawerToggle}
                        authuserrole={role}
                    />
                    {/* pt clears the fixed AppBar (~62px) with a small gap — not the
                        ~50px of dead space the old value left behind. */}
                    <Box component="main" sx={{ flex: 1, pt: (isSmUp ? 10 : 9), pb: 5, px: (isSmUp ? 3 : 1), bgcolor: 'background.default' }}>
                        <Routes>
                            <Route path="/" exact element={<Home navigatorWidth={drawerWidth} />} />
                            <Route path="/me" exact element={<Me />} />
                            <Route path="/users" exact element={<Users />} />
                            <Route path="/team" element={<Team />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/feeds" element={<Feeds />} />
                            <Route path="/reports/covers/:id" element={<CoverLetters />} />
                            <Route path="/feeds/covers/:id" element={<CoverLetters />} />
                            <Route path="/feeds/contents/:id" element={<FeedContents />} />
                            <Route path="/reports" element={<Reports />} />
                            <Route path="/tags" element={<Tags />} />
                            <Route path="/prompts" element={<Prompts />} />
                            <Route path="/portfolio" element={<Portfolio />} />
                            <Route path="/autoreply-email" element={<AutoreplyEmail />} />
                            
                            <Route path="*" element={
                                <Navigate to="/" />
                            } />
                        </Routes>
                    </Box>
                    <Box component="footer" sx={{ p: 2, bgcolor: 'background.default' }}>
                        <Copyright />
                    </Box>
                    <InactivityHandler />
                </Box>
            </Box>
        </ThemeProvider>
    );
}
